import React from "react";
import { Field } from "formik";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/material_blue.css"; 
import 'flatpickr/dist/l10n/es';

const FloatingLabelDatePicker = ({ label, ...props }) => {
  const langData = props.langdata;
  const pageName = props.langname;
  const langCode = props.langcode ? props.langcode : 'en';
  return (
    <div className="form-field">
      <Field name={props.name}>
        {({ field, form }) => (
          <div
            className={
              form.touched[props.keyName] && form.errors[props.keyName]
                ? "sign-up-sec form-group has-danger"
                : "sign-up-sec form-group"
            }
          >
            <Flatpickr
              {...field}
              {...props}
              options={{
                altInput: true,
                dateFormat: "Y-m-d",
                locale:langCode,
                maxDate: new Date(props.mindate),
                disable: [
                  function(date) {
                    // Disable dates beyond maxDate
                    return date > new Date(props.mindate);
                  }
                ],
              }}
              value={field.value}
              allowInput={false}
              onChange={(value) => {
                if(value && value[0] instanceof Date && !isNaN(value[0].getTime()) ){
                  const dateObj = new Date(value[0]);
                  const year = dateObj.getFullYear();
                  const month = (dateObj.getMonth() + 1).toString().padStart(2, '0');
                  const date = (dateObj.getDate() < 10 ? '0' : '') + dateObj.getDate();
                  let DateField = `${year}-${month}-${date}`
                  form.setFieldValue(field.name, DateField);
                }
              }}
              onBlur={form.handleBlur}
              className="custom-input dob-input"
              required
              id={props.keyname}
              onClose={() => {
                form.setFieldTouched(field.name)
              }}
              disabled={props?.disabled}
            >
            </Flatpickr >
            <label className="custom-label" htmlFor={props.keyname}>
              {(langData && langData[pageName + '_' + props.keyname]
                ? langData[pageName + '_' + props.keyname]
                : props.entiredata.title) +
                (props.entiredata?.required ? "*" : "")}
            </label>
            {form.touched[props.keyname] && form.errors[props.keyname] ? (
              <div
                className="error-msg"
                aria-label={form.errors[props.keyname]}
              >
                {form.errors[props.keyname]}
              </div>
            ) : null}
          </div>
        )}
      </Field>
    </div>
  );
};

export default FloatingLabelDatePicker;
